<!-- The main button element. It can be a <button> or an <a> tag.
     - [ngClass] applies all our dynamic CSS classes.
     - [disabled] attribute is bound to the state.
     - (click) emits the event.
     - [attr.aria-label] provides accessibility for icon-only buttons.
-->
<button
  [ngClass]="classes"
  [disabled]="disabled"
  (click)="onClick.emit($event)"
  [style.width]="width"
>
  <!-- Icon Container: Renders only if content is 'Icon' or 'Text + Icon' or 'Icon + Text' -->
  <span
    *ngIf="content === 'Icon' || content === 'Text + Icon' || content === 'Icon + Text'"
    class="btn__icon"
  >
    <!-- Render custom icon if provided -->
    <ng-container *ngIf="icon">
      <ng-container *ngIf="iconTemplate; else svgIcon">
        <ng-container *ngTemplateOutlet="iconTemplate"></ng-container>
      </ng-container>
      <ng-template #svgIcon>
        <span [innerHTML]="icon"></span>
      </ng-template>
    </ng-container>
    <!-- Fallback: Default SVG icon if no custom icon is provided -->
    <ng-container *ngIf="!icon"> ? </ng-container>
  </span>

  <ng-content *ngIf="!label"></ng-content>
  <span *ngIf="content !== 'Icon'" class="btn__text">
    {{ label }}
  </span>
</button>
